import { isProductionDomain } from 'korint-sdk';

export function isProduction(): boolean {
  return isProductionDomain(window.location.hostname);
}
